/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Titan, 2026-09-30: a top-level menu dropdown near the right edge (Operative, at desktop
// widths) hung past the edge of the page even while closed, which gave desktop browsers a
// sideways scrollbar and would have cut the open menu off. Any top-level dropdown that would
// run off the right edge is lined up with the right edge of its own menu item instead.
(function () {
  function fitDropdowns() {
    var width = document.documentElement.clientWidth;
    document.querySelectorAll('.nav-bar .nav-dropdown').forEach(function (dropdown) {
      if (dropdown.parentElement.closest('.nav-dropdown')) return; // sub-menus: the theme handles these
      dropdown.style.left = '';
      dropdown.style.right = '';
      if (dropdown.getBoundingClientRect().right > width) {
        dropdown.style.left = 'auto';
        dropdown.style.right = '-15px';
      }
    });
  }
  document.addEventListener('DOMContentLoaded', fitDropdowns);
  window.addEventListener('load', fitDropdowns);
  window.addEventListener('resize', fitDropdowns);
})();
